var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookingPerformance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.07143 18.6082H18.9286M6.07143 18.6082C4.65127 18.6082 3.5 17.457 3.5 16.0368V10.2511C3.5 9.18599 4.36345 8.32254 5.42857 8.32254C5.65398 8.32254 5.87036 8.36122 6.07143 8.43228M6.07143 18.6082V21.1797M18.9286 18.6082C20.3488 18.6082 21.5 17.457 21.5 16.0368V10.2511C21.5 9.18599 20.6365 8.32254 19.5714 8.32254C19.346 8.32254 19.1297 8.36122 18.9286 8.43228M18.9286 18.6082V21.1797M6.07143 8.43228C6.82049 8.69703 7.35714 9.4114 7.35714 10.2511V13.4654H17.6429V10.2511C17.6429 9.4114 18.1795 8.69703 18.9286 8.43228M6.07143 8.43228V8.32254C6.07143 5.48222 8.37396 3.17969 11.2143 3.17969H13.7857C16.626 3.17969 18.9286 5.48222 18.9286 8.32254V8.43228",
    stroke: "#D08759",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookingPerformance);
export default __webpack_public_path__ + "static/media/bookingPerformance.4bd5fe6a7b987557d2a4ff29549a062e.svg";
export { ForwardRef as ReactComponent };